export default {
  tokensLoadingState(state) {
    return state.loading;
  },
  allTokensListState(state) {
    return state.list || [];
  },
  pendingTokensState(state) {
    return state.list.filter(token => !token.id);
  },
  tokensByReferralIdState(state, getters) {
    let allReferralsIds = getters.allReferralsListState.map(referral => referral.id);
    allReferralsIds = [
      ...allReferralsIds,
      ...Object.values(getters.referralDetailsBySlugState).map(referral => referral.id)
    ];

    let tokensById = {};
    allReferralsIds.forEach(id => {
      tokensById[id] = state.list.filter(token => token.referral_id === id);
    });
    return tokensById;
  },
  isTokenGrantedByReferral: (state, getters) => (referralId, type) => {
    const tokens = getters.tokensByReferralIdState[referralId];
    let tokenTypes = tokens && tokens.map(token => (token.id ? token.type : null));
    return tokens && tokenTypes.includes(type);
  },
  tokensErrorState(state) {
    return state.error;
  },
  tokensMetaState(state) {
    return state.meta;
  }
};
